import React, { useState, useEffect } from "react";
import { Content, Main } from "../../../components/Layout";
import TableResponsive from "../../../components/TableResponsive";
import styleButton from "../../../components/Button/Button.module.css";
import ModalProduct from "../../../components/Modal/modal-product";
import useFormat from "../../../hooks/utils/useFormat";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import StatusFlag from "../../../components/StatusFlag";
import { ModaProductContribution } from "../../../components/Modal";

export default function Products() {
  const { commercial, reload, setreload } = useOutletContext();
  const [productModal, setproductModal] = useState({
    show: false,
    product_pre_load: null,
  });
  const { formatDate, formatReal } = useFormat();

  const { setbreadcrumb } = useWrapper();
  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  return (
    <>
      <ModalProduct
        show={productModal.show}
        productPreLoad={productModal.product_pre_load}
        commercial={commercial || []}
        closeModal={() => {
          setproductModal({ show: false, id: null });
        }}
        reload={() => {
          setreload(!reload);
        }}
        isProduct={true}
        payerPreLoad="produto"
      />
      <ModaProductContribution
        show={!!productModal?.contribution}
        closeModal={() => {
          setproductModal({ show: false, id: null, contribution: null });
        }}
        productPreLoad={productModal.product_pre_load}
      />
      <Main>
        {!commercial ? (
          <Content>
            <Loading />
          </Content>
        ) : (
          <Content>
            <div className="d-flex justify-content-between mb-4">
              <h2 className="form-title">Loja Virtual</h2>
              <button
                className={styleButton.button_ghost}
                onClick={() => {
                  setproductModal({ show: true, product_pre_load: null });
                }}
              >
                <span>Adicionar Produto</span>
              </button>
            </div>
            <TableResponsive
              table={{
                head: [
                  { data: "Produto" },
                  { data: "Período" },
                  { data: "Disponibilidade" },
                  { data: "Valor" },
                  { data: "" },
                ],
                body:
                  commercial?.products?.map(__payment => ({
                    onClick: () => {
                      if (__payment.status === "Encerrado" || __payment.status === "Aguardando Finalização") {
                        setproductModal({
                          contribution: true,
                          product_pre_load: __payment,
                        });
                      } else {
                        setproductModal({
                          show: true,
                          product_pre_load: __payment,
                        });
                      }
                    },
                    data: [
                      { element: __payment.name },
                      {
                        element: `${formatDate(__payment.date_start, 2)} ~ ${formatDate(__payment.date_end, 2)}`,
                      },
                      { element: __payment.quantity },
                      {
                        element: formatReal((__payment.value || 0) + (__payment.contribution_value || 0)),
                      },
                      {
                        element: (
                          <div className="text-end">
                            <StatusFlag status={__payment.status} />
                          </div>
                        ),
                      },
                    ],
                  })) || [],
              }}
            />
          </Content>
        )}
      </Main>
    </>
  );
}
